module.exports = __webpack_public_path__ + "img/Indonesia-12.0ab63549.jpg";